import AlertNotification from '../components/AlertNotification';

export default {
  init() {
    this.initHandlers();
  },

  initHandlers() {
    const $form = $('.j-form-edit-dependencies');
    $('.j-form-edit-dependencies').on('change', e => {
      const switcher = $(e.target).closest('.j-switcher-empty');
      const tr = $(e.target).closest('tr');
      const select = tr.find('select');

      if (switcher.length) {
        if (switcher.find('input:checked').length) {
          this.deselectItems(tr);
          updateButtonStates(select[0]);
        } else {
          this.deselectEmpty(tr);
          updateButtonStates(select[0]);
        }
      } else if (select.length) {
        this.deselectCheckbox(tr);
        updateButtonStates(select[0]);
      }
    });

    const updateButtonStates = select => {
      const selectAllButton = select.closest('td').querySelector('#select_all');
      const clearAllButton = select.closest('td').querySelector('#clear_all');
      const options = Array.from(select.options).filter(option => !option.classList.contains('d-none'));

      const allSelected = options.every(option => option.selected);
      const anySelected = options.some(option => option.selected);

      if (selectAllButton) {
        selectAllButton.disabled = !!allSelected;
      }

      if (clearAllButton) {
        clearAllButton.disabled = !anySelected;
      }
    };

    $('option').mousedown(function (e) {
      e.preventDefault();
      const $parent = $(this).parent();
      const originalScrollTop = $parent.scrollTop();
      $(this).prop('selected', !$(this).prop('selected'));
      $parent.focus();
      setTimeout(() => $parent.scrollTop(originalScrollTop), 0);
      updateButtonStates($parent[0]);
      return false;
    });

    document.querySelectorAll('select').forEach(select => {
      select.addEventListener('change', () => updateButtonStates(select));
      updateButtonStates(select);
    });

    document.querySelectorAll('#select_all').forEach(button => {
      button.addEventListener('click', () => {
        const select = button.closest('td').querySelector('select');

        Array.from(select.options).forEach(option => {
          if (!option.classList.contains('d-none')) {
            option.selected = true;
          } else if (option.text === '__empty') {
            option.selected = false;
            option.removeAttribute('selected');
          }
        });

        updateButtonStates(select);
      });
    });

    document.querySelectorAll('#clear_all').forEach(button => {
      button.addEventListener('click', () => {
        const select = button.closest('td').querySelector('select');
        Array.from(select.options).forEach(option => {
          option.selected = false;
        });
        updateButtonStates(select);
      });
    });

    $form.on('submit', e => {
      e.preventDefault();
      $form.find("option:contains('__none_selected')").each((index, item) => {
        if (!$(item).closest('tr').find('.j-switcher-empty input').is(':checked')) {
          $(item).prop('selected', true);
          $(item).attr('selected', 'selected');
        }
      });

      $.ajax({
        type: 'POST',
        url: $form.attr('action'),
        data: JSON.stringify($form.serializeArray()),
        dataType: 'json',
        success(data) {
          AlertNotification.RemoveHtml($form.find('.card'), true);
          document.location.href = `/${data.data.link}`;
        },
        error(err) {
          AlertNotification.AppendHtml('error', err.responseJSON.error, $form.find('.card'), true);
        },
      });
    });
  },

  deselectItems(tr) {
    tr.find('option:selected').each((index, item) => {
      $(item).prop('selected', false);
    });
    tr.find("option:contains('__empty')").prop('selected', true);
    tr.find("option:contains('__empty')").attr('selected', 'selected');
  },

  deselectEmpty(tr) {
    tr.find('option:selected').each((index, item) => {
      $(item).prop('selected', false);
    });
  },

  deselectCheckbox(tr) {
    const emptyOption = tr.find("option:contains('__empty')");

    if (emptyOption.attr('selected')) {
      emptyOption.prop('selected', false);
      emptyOption.removeAttr('selected');
    }

    if (tr.find('input').is(':checked')) {
      tr.find('input').prop('checked', false);
      tr.find('input').removeAttr('checked');
    }
  },
};
